import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import Modal from 'components/modal/modal';
import { breakpointSmallTablet } from 'common/constants';
const DRAWER_MOBILE_WIDTH = '256px';
const DRAWER_DEFAULT_WIDTH = '80vw'; // desktop default for now

const drawerStyles = "dw4vh5s";
export const Drawer = ({
  children,
  isOpen,
  handleClose,
  appRootSelector,
  screenReaderLabel
}) => {
  return <Modal appRootSelector={appRootSelector} screenReaderLabel={screenReaderLabel} handleClose={handleClose} isOpen={isOpen} className="modal-drawer" // necessary for style override
  overlayClassName="drawer" // necessary for style override
  portalClassName={drawerStyles} showCloseButton={false} closeTimeoutMS={200}>
      <div>{children}</div>
    </Modal>;
};
Drawer.propTypes = {
  /**
   * Content of the Drawer (e.g. nav buttons)
   */
  children: PropTypes.node.isRequired,
  /**
   * Boolean indicating whether the Drawer should be open
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Function that will be run when the Drawer is requested
   to be closed
   */
  handleClose: PropTypes.func.isRequired,
  /**
   * query selector specifying root element of React App (e.g. '#root')
   */
  appRootSelector: PropTypes.string.isRequired,
  /**
   * String indicating how the content container should be announced
   to screen readers
   */
  screenReaderLabel: PropTypes.string.isRequired
};

require("./drawer.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./drawer.js");